<template>
  <GlobalWindow
      :title="title"
      :visible.sync="visible"
      :confirm-working="isWorking"
      @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="案例名称" prop="projectName" required>
        <el-input v-model="form.projectName" placeholder="请输入案例名称"/>
      </el-form-item>
      <el-form-item label="交付文件前缀" prop="keyword">
        <el-input v-model="form.keyword" placeholder="请输入交付文件前缀" prefix="el-icon-search"/>
      </el-form-item>
      <el-form-item label="是否加急" prop="withPriority" required>
        <el-switch v-model="form.withPriority"/>
      </el-form-item>
      <el-form-item label="是否全程代理" prop="withProxy" required>
        <el-switch v-model="form.withProxy"/>
      </el-form-item>
      <el-form-item label="价格" prop="keyword">
        <el-input v-model="form.price" placeholder="请输入价格"/>
      </el-form-item>
      <el-form-item label="项目备注" prop="projectRemark">
        <el-input type="textarea" :rows="5" v-model="form.projectRemark" :maxlength="200" placeholder="请输入项目备注"/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import GlobalWindow from '../common/GlobalWindow'
import BaseOpera from '../base/BaseOpera'
export default {
  name: 'OperaProjectWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      form: {
        id: null,
        projectName: '',
        projectRemark: '',
        withPriority: false,
        withProxy: false,
        price: '',
        keyword: ''
      },
      rules: {
        projectName: [
          { required: true, message: '请输入项目名称' }
        ]
      }
    }
  },
  created () {
    this.config({
      api: '/customer/project',
      'field.id': 'id'
    })
  }
}
</script>

<style scoped lang="scss">
.el-input {
  width: 130px;
}
</style>
